import { convertReliabilityScoreToDisplayValue } from '@careerstart/wae-common/src/main/helperFunction/convertReliabilityScoreToDisplayValue';

import useFairReliabilityScore from '../../utils/useFairReliabilityScore';

const useCandidateReliabilityDisplay = (metrics) => {
  const { pickReliability, canSeeAls } = useFairReliabilityScore();

  return {
    reliabilityScore: convertReliabilityScoreToDisplayValue(
      pickReliability(metrics?.rawReliability, metrics?.reliabilityScore)
    ),
    appearanceLikelihoodScore: canSeeAls
      ? convertReliabilityScoreToDisplayValue(metrics?.rawAls)
      : undefined,
  };
};

export default useCandidateReliabilityDisplay;
